import { DateTime } from "luxon";

const PASSION_FRIDAY_INTERVAL_DAYS = 21;
const STOCKHOLM_TIME_ZONE = "Europe/Stockholm";

export function isPassionFriday(
  now: DateTime = DateTime.now(),
): boolean {
  const passionFridayAnchor = process.env.REACT_APP_PASSION_FRIDAY_ANCHOR;

  if (!passionFridayAnchor) {
    throw new Error(
      "Missing required environment variable REACT_APP_PASSION_FRIDAY_ANCHOR",
    );
  }

  const anchor = DateTime.fromISO(passionFridayAnchor, {
    zone: STOCKHOLM_TIME_ZONE,
  }).startOf("day");
  const today = now.setZone(STOCKHOLM_TIME_ZONE).startOf("day");
  const daysFromAnchor = today.diff(anchor, "days").days;

  return daysFromAnchor % PASSION_FRIDAY_INTERVAL_DAYS === 0;
}
